
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0.666748 8.99935C0.666748 4.39935 4.40008 0.666016 9.00008 0.666016C13.6001 0.666016 17.3334 4.39935 17.3334 8.99935C17.3334 13.5993 13.6001 17.3327 9.00008 17.3327C4.40008 17.3327 0.666748 13.5993 0.666748 8.99935ZM7.33341 6.08268V11.916C7.33341 12.2577 7.72508 12.4577 8.00008 12.2493L11.8917 9.33268C12.1167 9.16601 12.1167 8.83268 11.8917 8.66601L8.00008 5.74935C7.72508 5.54101 7.33341 5.74101 7.33341 6.08268Z","fill":"#BD0F16"}})])
          )
        }
      }
    